import { render, staticRenderFns } from "./NewEarnings.vue?vue&type=template&id=64db75c5&scoped=true"
import script from "./NewEarnings.vue?vue&type=script&lang=js"
export * from "./NewEarnings.vue?vue&type=script&lang=js"
import style0 from "./NewEarnings.vue?vue&type=style&index=0&id=64db75c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db75c5",
  null
  
)

export default component.exports